import React from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'

import Icon from '../../icon'

import Button from '../../button'

import ArrowRight from '../../icon/arrow-right.svg'

const See = ({ resource, ...attrs }) => {
  attrs.background = true

  return <Link
    href={`/recursos/${resource.id}/${resource.meta.slug}`}>
    <Button
      {...attrs}>
      Detalles {' '}
      <Icon
        svg={ArrowRight}
        width="24"
        height="24"
        className="ml-2"
      />
    </Button>
  </Link>
}

See.propTypes = {
  resource: PropTypes.object
}

export default See
